<script setup lang="ts">
const { isAuthenticated } = useAuth();

// definePageMeta({
//     middleware: 'root',
// });
onMounted(() => {

    if (!isAuthenticated.value) {
        return navigateTo("/sign-in");
    } else {
        return navigateTo("/event/T7dRz3cyRcnBgGLiQTjh");
    }
});
</script>
<template>
    <div>
        <NuxtPage />
    </div>
</template>